import { render, staticRenderFns } from "./SectionGamedayPreview.vue?vue&type=template&id=1b46c319&scoped=true&"
import script from "./SectionGamedayPreview.vue?vue&type=script&lang=js&"
export * from "./SectionGamedayPreview.vue?vue&type=script&lang=js&"
import style0 from "./SectionGamedayPreview.vue?vue&type=style&index=0&id=1b46c319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46c319",
  null
  
)

export default component.exports